/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Modules which admit settings
 */
export enum EnumDocumentSettingModuleName {
    /**
     * No module
     */
    NotDefined = 0,
    /**
     * Accounting export module
     */
    AccountingExport = 1,
}
